import moment from "moment";
import localizeConstants from "./localization-constants.js";

var zhCn = moment.defineLocale("en", {
  months: `${localizeConstants.Lbl.months.Jan}_${localizeConstants.Lbl.months.Feb}_${localizeConstants.Lbl.months.Mar}_${localizeConstants.Lbl.months.Apr}_${localizeConstants.Lbl.months.May}_${localizeConstants.Lbl.months.Jun}_${localizeConstants.Lbl.months.Jul}_${localizeConstants.Lbl.months.Aug}_${localizeConstants.Lbl.months.Sep}_${localizeConstants.Lbl.months.Oct}_${localizeConstants.Lbl.months.Nov}_${localizeConstants.Lbl.months.Dec}`.split(
    "_"
  ),
  monthsShort: `${localizeConstants.Lbl.months.Jan}_${localizeConstants.Lbl.months.Feb}_${localizeConstants.Lbl.months.Mar}_${localizeConstants.Lbl.months.Apr}_${localizeConstants.Lbl.months.May}_${localizeConstants.Lbl.months.Jun}_${localizeConstants.Lbl.months.Jul}_${localizeConstants.Lbl.months.Aug}_${localizeConstants.Lbl.months.Sep}_${localizeConstants.Lbl.months.Oct}_${localizeConstants.Lbl.months.Nov}_${localizeConstants.Lbl.months.Dec}`.split(
    "_"
  ),
  weekdays: `${localizeConstants.Lbl.weeks.Sun}_${localizeConstants.Lbl.weeks.Mon}_${localizeConstants.Lbl.weeks.Tue}_${localizeConstants.Lbl.weeks.Wed}_${localizeConstants.Lbl.weeks.Thu}_${localizeConstants.Lbl.weeks.Fri}_${localizeConstants.Lbl.weeks.Sat}`.split(
    "_"
  ),
  weekdaysShort: `${localizeConstants.Lbl.weeks.sSun}_${localizeConstants.Lbl.weeks.sMon}_${localizeConstants.Lbl.weeks.sTue}_${localizeConstants.Lbl.weeks.sWed}_${localizeConstants.Lbl.weeks.sThu}_${localizeConstants.Lbl.weeks.sFri}_${localizeConstants.Lbl.weeks.sSat}`.split(
    "_"
  ),
  weekdaysMin: `${localizeConstants.Lbl.weeks.mSun}_${localizeConstants.Lbl.weeks.mMon}_${localizeConstants.Lbl.weeks.mTue}_${localizeConstants.Lbl.weeks.mWed}_${localizeConstants.Lbl.weeks.mThu}_${localizeConstants.Lbl.weeks.mFri}_${localizeConstants.Lbl.weeks.mSat}`.split(
    "_"
  ),
  longDateFormat: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "YYYY/MM/DD",
    LL: "YYYY年M月D日",
    LLL: "YYYY年M月D日Ah点mm分",
    LLLL: "YYYY年M月D日ddddAh点mm分",
    l: "YYYY/M/D",
    ll: "YYYY年M月D日",
    lll: "YYYY年M月D日 HH:mm",
    llll: "YYYY年M月D日dddd HH:mm"
  },
  meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
  meridiemHour: function(hour, meridiem) {
    if (hour === 12) {
      hour = 0;
    }
    if (meridiem === "凌晨" || meridiem === "早上" || meridiem === "上午") {
      return hour;
    } else if (meridiem === "下午" || meridiem === "晚上") {
      return hour + 12;
    } else {
      // '中午'
      return hour >= 11 ? hour : hour + 12;
    }
  },
  meridiem: function(hour, minute, isLower) {
    var hm = hour * 100 + minute;
    if (hm < 600) {
      return "凌晨";
    } else if (hm < 900) {
      return "早上";
    } else if (hm < 1130) {
      return "上午";
    } else if (hm < 1230) {
      return "中午";
    } else if (hm < 1800) {
      return "下午";
    } else {
      return "晚上";
    }
  },
  calendar: {
    sameDay: "[今天]LT",
    nextDay: "[明天]LT",
    nextWeek: function(now) {
      if (now.week() !== this.week()) {
        return "[下]dddLT";
      } else {
        return "[本]dddLT";
      }
    },
    lastDay: "[昨天]LT",
    lastWeek: function(now) {
      if (this.week() !== now.week()) {
        return "[上]dddLT";
      } else {
        return "[本]dddLT";
      }
    },
    sameElse: "L"
  },
  dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
  ordinal: function(number, period) {
    switch (period) {
      case "d":
      case "D":
      case "DDD":
        return number + "日";
      case "M":
        return number + "月";
      case "w":
      case "W":
        return number + "周";
      default:
        return number;
    }
  },
  relativeTime: {
    future: "%s后",
    past: "%s前",
    s: "几秒",
    ss: "%d 秒",
    m: "1 分钟",
    mm: "%d 分钟",
    h: "1 小时",
    hh: "%d 小时",
    d: "1 天",
    dd: "%d 天",
    w: "1 周",
    ww: "%d 周",
    M: "1 个月",
    MM: "%d 个月",
    y: "1 年",
    yy: "%d 年"
  },
  week: {
    // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
    dow: 1, // Monday is the first day of the week.
    doy: 4 // The week that contains Jan 4th is the first week of the year.
  }
});
console.log(
  "${localizeConstants.Lbl.months.Jan}",
  localizeConstants.Lbl.weeks.Mon
);

export default zhCn;
